// import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useEffect, useState } from 'react';
import TableCompHead from '../../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { TableInput } from '../../../../../components/common';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';
import axios from 'axios';
import { AutoComplete } from '../../helpers/interface';

interface IProps {
  moduleData: any;
  isView: boolean;
  autoCompleteList: AutoComplete[] | null;
}
const getYearRange = (currentDate: any) => {
  if (!currentDate) return;
  const year = new Date(currentDate).getFullYear();
  return `${year} - ${year + 1}`;
};

const theadData = [
  'S.No.',
  'Area Of Process',
  'Particulars Area of Functions',
  'Average Noise in Db.',
  'April',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
  'Jan',
  'Feb',
  'Mar',
  'Remarks',
];

const THead = ({ moduleData, isView, autoCompleteList }: IProps) => {
  const [render, setRender] = useState(false);
  const yearRange = getYearRange(moduleData?.createdAt) || ''
  return (
    <thead>
      <TableCompHead
        colSpan={17}
        rowSpan={3}
        labels={['Doc No', 'Rev No.', 'Eff. Date:']}
        values={['F/QA/25', '00', '01.12.2020']}
        heading={`Noise Monitoring Report ${yearRange}`}
      />
      <tr style={{background:"#38d9a9"}}>
        <th colSpan={4} rowSpan={2} align="center">
        Ref. Standard - 
Noise standards (as notified in Environment (Protection) Rules,1986)
        </th>
        <th colSpan={13} rowSpan={2} align="center">
        Observations
        </th>
      </tr>
      <tr></tr>
      <tr style={{background:"#38d9a9"}}>
        {theadData.map((heading, index) => (
          <th key={heading} rowSpan={2}>{heading}</th>
        ))}
      </tr>
    
    </thead>
  );
};

export default THead;
